// React 엔트리 — Router + QueryClient + ToastProvider 배선.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { ToastProvider } from './components/Toast';
import { installSwAutoReload } from './utils/swAutoReload';
import './styles.css';
// styles.css 기본 규칙을 덮는 오버라이드 — 반드시 styles.css 다음 (cascade 순서)
import './styles/overrides.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,        // 401·400 자동 재시도 금지
      staleTime: 10_000,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});

// 배포 후 새로고침 1회로 새 버전이 반영되도록 — 새 SW가 제어권을 가져오면 1회 reload
installSwAutoReload();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root 엘리먼트를 찾을 수 없습니다');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
